import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ILegalDocumentLink } from '../../types/link';

export enum ELinksActionTypes {
  SetLinks = 'LINKS/SET_STATE',
}

export type TSetLinks = ITypedReduxAction<ELinksActionTypes.SetLinks, ILegalDocumentLink[]>;

/**
 * Redux action, который записывает в store ссылки на документы
 * @param features IConfigFeatures
 */
export const setLinks = actionGenerator<ELinksActionTypes.SetLinks, ILegalDocumentLink[]>(ELinksActionTypes.SetLinks);
